import Vue from "vue";
import Vuex from "vuex";
import {dict,imageList } from "@/api/index"

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    proAdress:"",
    proId:2,
    proNav:0,
    navLeft:[],
    listNav:{}//导航栏名称

  },
  mutations: {
    
  },
  actions: {
    // // 获取用户信息
    // GetDict({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     dict(state.dict).then(res => {
    //       // const user = res.user
    //       resolve(res)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
  },
  modules: {}
});
